/**
 * -----------------------------------------------------------------------------
 * It renders the checked checkbox icon in dark gray color.
 */
export function CheckedCheckboxIcon() {
  return (
    <svg
      fill="none"
      style={{ width: 24 }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#a)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path
          className="fill-stone-800 stroke-stone-800"
          d="M19.5 3.75h-15a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75Z"
        />
        <path className="stroke-stone-50" d="M8.25 12.75 10.5 15l5.25-5.25" />
      </g>
      <defs>
        <clipPath id="a">
          <path className="stroke-stone-50" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
